import React from 'react'

/**
 * Queza app icon, inline (same artwork as the booking site's /brand/queza-app-icon.svg).
 * Inline on purpose: no image request, can't be cached stale or mangled in transit.
 */
const BrandLogo: React.FC<{ size?: number; className?: string; dark?: boolean }> = ({ size = 36, className = '', dark }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    role="img"
    aria-label="Queza"
    className={`flex-shrink-0 ${className}`}
  >
    <rect width="512" height="512" rx="112" fill={dark ? '#14211A' : '#06C755'} />
    <g fill={dark ? '#06C755' : '#fff'} transform="translate(76 76) scale(.703125)">
      <path
        fillRule="evenodd"
        d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c27.5 0 53.8-5.3 77.8-15l-58.2-58.2A137 137 0 0 1 256 392c-75.1 0-136-60.9-136-136s60.9-136 136-136 136 60.9 136 136c0 23.4-5.9 45.5-16.3 64.7l53.5 53.5A206.9 206.9 0 0 0 464 256C464 141.1 370.9 48 256 48Z"
      />
      <path d="M288.8 309.4a16 16 0 0 1 22.6 0l117.2 117.2a32 32 0 0 1-45.2 45.2L266.2 354.6a16 16 0 0 1 0-22.6l22.6-22.6Z" />
    </g>
  </svg>
)

export default BrandLogo
